module.exports = __webpack_public_path__ + "static/media/inscriptions.675a11ae.pdf";